import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Seo from '../../components/common/Seo.jsx';

export default function NotFoundPage() {
  return (
    <section className="container page-block notfound">
      <Seo title="Page Not Found" noindex />
      <div className="notfound-code">404</div>
      <h1>This cell of the hive is empty</h1>
      <p style={{ color: 'var(--muted)', maxWidth: 440, margin: '14px auto 28px' }}>
        The page you are looking for has buzzed off. Let&rsquo;s get you back to the honey.
      </p>
      <div className="center-actions">
        <Link className="button button-honey" to="/"><ArrowLeft size={17} /> Back to the Store</Link>
      </div>
    </section>
  );
}
